export default __webpack_public_path__ + "static/media/Logo-OMS.a6075228.svg";